export const routerAddress = "0xbc95A152048357f29D5E6362dFC33493bf3A7Fe7";
export const factoryAddress = "0x9828706a383442dFD91c76210c0fdbeAcc665aAA";
export const WETHAddress = "0x4200000000000000000000000000000000000006";
// DAI : 0xF843A6521E8793c80e29677DB92d895d5Fd85479
